import React from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import foundingPartnerBadge from '../../assets/founding_partner_badge.png';
import './FoundingPartnerBadge.scss';

/**
 * Founding Partner Badge Component
 * @param {string} size - 'small' (16px), 'medium' (24px), 'large' (36px)
 * @param {boolean} showTooltip - Whether to show tooltip on hover
 * @param {string} className - Additional CSS classes
 */
const FoundingPartnerBadge = ({ size = 'medium', showTooltip = true, className = '' }) => {
  const { t } = useTranslation();

  const sizeMap = {
    small: 18,
    medium: 26,
    large: 40
  };

  const pixelSize = sizeMap[size] || sizeMap.medium;

  const badge = (
    <span className={`founding-partner-badge founding-partner-badge--${size} ${className}`}>
      <img
        src={foundingPartnerBadge}
        alt="Founding Partner"
        width={pixelSize}
        height={pixelSize}
      />
    </span>
  );

  if (showTooltip) {
    return (
      <Tooltip title={t('partners.profile.foundingPartner')} placement="top">
        {badge}
      </Tooltip>
    );
  }

  return badge;
};

export default FoundingPartnerBadge;
